import ENV from "./ENV";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";
import textHelpers from "app/utils/textHelpers";
import * as Font from "expo-font";

import {
  createIconSetFromFontello,
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  AntDesign,
  FontAwesome,
  FontAwesome5,
  Fontisto,
  Entypo,
  Octicons,
  Foundation,
  Feather,
} from "@expo/vector-icons";

import fontelloConfig from "root/assets/fonts/config.json";
const Fontello = createIconSetFromFontello(
  fontelloConfig,
  "fontello",
  "fontello.ttf",
);

let iconHelpers = {
  async _loadAssetsAsync() {
    const cacheFonts = (fonts) => {
      return fonts.map((font) => Font.loadAsync(font));
    };

    const fontAssets = cacheFonts([
      Ionicons.font,
      MaterialCommunityIcons.font,
      MaterialIcons.font,
      AntDesign.font,
      FontAwesome.font,
      // FontAwesome5.font,
      Fontisto.font,
      Entypo.font,
      Octicons.font,
      Foundation.font,
      Feather.font,
      // Fontello.font,
    ]);
    await Promise.all([...fontAssets]);

    let customFonts = {
      fontello: require("root/assets/fonts/fontello.ttf"),
      IcoMoon: require("root/assets/fonts/icomoon.ttf"),
    };
    if (!ENV.WEB) {
      await Font.loadAsync(customFonts);
    }
  },
  iconColor(value) {
    let color = value.color || value.inheritedColor;
    // let opacity = ENV.LIGHT ? 0.4 : 0.2
    let opacity = 0.2;
    let colorString = value.colorString;
    if (!colorString) {
      let inheritedColor = valueHelpers.hexAsColor(value.inheritedColor);
      colorString = valueHelpers.hexAsColor(inheritedColor);
    }
    if (colorString == "blue") opacity = 0.4;
    if (colorString == "purple") opacity = 0.5;
    if (colorString == "black") opacity = 0.6;
    // if(ENV.LIGHT){
    //   if(colorString == 'lime') opacity = 0.3
    //   if(colorString == 'green') opacity = 0.8
    //   if(colorString == 'brown') opacity = 0.8
    //   if(colorString == 'yellow') opacity = 0.25
    //   if(colorString == 'magenta') opacity = 0.6
    // }
    // else {
    //   if(colorString == 'lime') opacity = 0.15
    // }
    return { color, opacity };
  },
  iconOptions(includeHidden = false) {
    return Object.keys(iconHelpers.allIconClasses(includeHidden));
  },
  findIconClass(name = "select") {
    if (!!name) {
      return iconHelpers.allIconClasses(true)[name];
    } else {
      return iconHelpers.allIconClasses()["none"];
      // return { name: "", iconName: "", iconClass: {} };
    }
  },
  allIconClasses(includeHidden = false) {
    let icons = {
      // select: {
      //   name: "select",
      //   iconName: "selection-ellipse",
      //   iconClass: MaterialCommunityIcons,
      // },
      none: {
        name: "",
        iconName: "",
        iconClass: MaterialCommunityIcons,
      },

      // people
      person: { name: "person", iconName: "person", iconClass: Octicons },
      tie: { name: "tie", iconName: "user-tie", iconClass: FontAwesome5 },
      personal: {
        name: "personal",
        iconName: "person-pin",
        iconClass: MaterialIcons,
      },
      community: {
        name: "community",
        iconName: "account-group",
        iconClass: MaterialCommunityIcons,
      },
      friends: {
        name: "friends",
        iconName: "user-friends",
        iconClass: FontAwesome5,
        scale: 0.9,
      },
      "heart-person": {
        name: "heart-person",
        iconName: "account-heart",
        iconClass: MaterialCommunityIcons,
      },
      voice: {
        name: "voice",
        iconName: "record-voice-over",
        iconClass: MaterialIcons,
      },

      // activities
      run: { name: "run", iconName: "run", iconClass: MaterialCommunityIcons },
      bike: {
        name: "bike",
        iconName: "directions-bike",
        iconClass: MaterialIcons,
      },
      moped: {
        name: "moped",
        iconName: "moped",
        iconClass: MaterialIcons,
        scale: 1.1,
      },
      car: {
        name: "car",
        iconName: "car",
        iconClass: FontAwesome5,
      },
      wheel: {
        name: "wheel",
        iconName: "wheel",
        iconClass: Fontello,
        // scale: 0.9,
      },
      hike: {
        name: "hike",
        iconName: "biathlon",
        iconClass: MaterialCommunityIcons,
      },
      chat: { name: "chat", iconName: "chatbubbles", iconClass: Ionicons },
      thought: {
        name: "thought",
        iconName: "thought-bubble",
        iconClass: MaterialCommunityIcons,
      },
      vulnerability: {
        name: "vulnerability",
        iconName: "hand-holding-heart",
        iconClass: FontAwesome5,
      },
      charity: {
        name: "charity",
        iconName: "charity",
        iconClass: MaterialCommunityIcons,
      },
      hearts: {
        name: "hearts",
        iconName: "heart-multiple",
        iconClass: MaterialCommunityIcons,
      },

      // things
      search: { name: "search", iconName: "search", iconClass: Feather },
      apple: {
        name: "apple",
        iconName: "food-apple",
        iconClass: MaterialCommunityIcons,
      },
      book: {
        name: "book",
        iconName: "book-open-page-variant",
        iconClass: MaterialCommunityIcons,
      },
      notebook: {
        name: "notebook",
        iconName: "notebook",
        iconClass: MaterialCommunityIcons,
      },
      bread: {
        name: "bread",
        iconName: "baguette",
        iconClass: MaterialCommunityIcons,
      },
      pencil: {
        name: "pencil",
        iconName: "pencil",
        iconClass: FontAwesome,
        scale: 0.9,
      },
      coins: {
        name: "coins",
        iconName: "coins",
        iconClass: FontAwesome5,
        scale: 0.9,
      },
      broom: {
        name: "broom",
        iconName: "broom",
        iconClass: MaterialCommunityIcons,
        scale: 1.1,
      },
      lamp: {
        name: "lamp",
        iconName: "lamp",
        iconClass: MaterialCommunityIcons,
      },
      glasses: {
        name: "glasses",
        iconName: "glasses",
        iconClass: MaterialCommunityIcons,
      },
      utensils: {
        name: "utensils",
        iconName: "silverware-variant",
        iconClass: MaterialCommunityIcons,
      },
      candle: {
        name: "candle",
        iconName: "candle",
        iconClass: MaterialCommunityIcons,
      },
      // 'no-phone': { name: 'no-phone', iconName: 'phonelink-erase', iconClass: MaterialIcons },
      "no-phone": {
        name: "no-phone",
        iconName: "cellphone-off",
        iconClass: MaterialCommunityIcons,
      },
      tv: { name: "tv", iconName: "tv", iconClass: Feather },
      computer: {
        name: "computer",
        iconName: "computer",
        iconClass: MaterialIcons,
      },
      keyboard: {
        name: "keyboard",
        altNames: ["computer"],
        iconName: "keyboard",
        iconClass: Entypo,
      },
      gamepad: {
        name: "gamepad",
        iconName: "gamepad",
        iconClass: FontAwesome,
        scale: 0.9,
      },
      headphones: {
        name: "headphones",
        iconName: "headphones",
        iconClass: FontAwesome5,
      },
      lightbulb: {
        name: "lightbulb",
        iconName: "bulb-outline",
        iconClass: Ionicons,
      },
      socks: {
        name: "socks",
        iconName: "socks",
        iconClass: FontAwesome5,
        scale: 0.9,
      },
      // tshirt: { name: "tshirt", iconName: "tshirt", iconClass: FontAwesome5 },
      tshirt: {
        name: "tshirt",
        iconName: "tshirt-crew",
        iconClass: MaterialCommunityIcons,
      },
      paints: {
        name: "paints",
        iconName: "color-lens",
        iconClass: MaterialIcons,
      },
      tools: { name: "tools", iconName: "tools", iconClass: Entypo },
      hammer: { name: "hammer", iconName: "hammer", iconClass: FontAwesome5 },
      compass: {
        name: "compass",
        iconName: "compass",
        iconClass: Ionicons,
      },
      map: { name: "map", iconName: "map", iconClass: FontAwesome, scale: 0.9 },
      piano: {
        name: "piano",
        iconName: "piano",
        iconClass: MaterialCommunityIcons,
      },
      camera: {
        name: "camera",
        iconName: "camera",
        iconClass: FontAwesome,
        scale: 0.8,
      },
      photo: {
        name: "photo",
        iconName: "photo",
        iconClass: FontAwesome,
        scale: 0.9,
      },
      film: {
        name: "film",
        iconName: "movie-roll",
        iconClass: MaterialCommunityIcons,
      },
      // 'syringe': { name: 'syringe', iconName: 'syringe', iconClass: FontAwesome5 },
      // 'gem': { name: 'gem', iconName: 'gem', iconClass: FontAwesome5 },

      // places
      home: { name: "home", iconName: "home", iconClass: FontAwesome5 },
      city: { name: "city", iconName: "city", iconClass: FontAwesome5 },
      city: {
        name: "city",
        iconName: "city",
        iconClass: MaterialCommunityIcons,
      },
      bridge: {
        name: "bridge",
        iconName: "bridge",
        iconClass: MaterialCommunityIcons,
        scale: 1.1,
      },
      mountain: {
        name: "mountain",
        iconName: "mountains",
        iconClass: Foundation,
      },
      campfire: {
        name: "campfire",
        iconName: "campfire",
        iconClass: MaterialCommunityIcons,
      },
      earth: { name: "earth", iconName: "earth", iconClass: Fontisto },
      "cloud-moon": {
        name: "cloud-moon",
        iconName: "cloud-moon",
        iconClass: FontAwesome5,
        scale: 0.9,
      },
      planet: { name: "planet", iconName: "planet", iconClass: Ionicons },
      plane: { name: "plane", iconName: "plane", iconClass: FontAwesome },
      rocket: {
        name: "rocket",
        iconName: "rocket",
        iconClass: FontAwesome5,
        scale: 0.8,
      },
      car: { name: "car", iconName: "car", iconClass: MaterialCommunityIcons },

      // nature
      seedling: {
        name: "seedling",
        iconName: "seedling",
        iconClass: FontAwesome5,
        scale: 0.9,
      },
      feather: {
        name: "feather",
        iconName: "feather-alt",
        iconClass: FontAwesome5,
        scale: 0.8,
      },
      turtle: {
        name: "turtle",
        iconName: "tortoise",
        iconClass: MaterialCommunityIcons,
      },
      cat: {
        name: "cat",
        iconName: "cat",
        iconClass: FontAwesome5,
        scale: 0.9,
      },
      pig: { name: "pig", iconName: "pig", iconClass: MaterialCommunityIcons },
      alien: {
        name: "alien",
        iconName: "alien",
        iconClass: MaterialCommunityIcons,
      },
      smile: {
        name: "smile",
        iconName: "smileo",
        iconClass: AntDesign,
      },
      meh: {
        name: "meh",
        iconName: "meh",
        iconClass: AntDesign,
      },
      frown: {
        name: "frown",
        iconName: "frowno",
        iconClass: AntDesign,
      },
      "blank-face": {
        name: "blank-face",
        iconName: "meh-blank",
        iconClass: FontAwesome5,
      },

      // fun
      chef: {
        name: "chef",
        iconName: "chef-hat",
        iconClass: MaterialCommunityIcons,
      },
      "crystal-ball": {
        name: "crystal-ball",
        iconName: "crystal-ball",
        iconClass: MaterialCommunityIcons,
      },
      wizard: {
        name: "wizard",
        iconName: "hat-wizard",
        iconClass: FontAwesome5,
        scale: 0.9,
      },
      "playing-cards": {
        name: "playing-cards",
        // iconName: "cards-playing-outline",
        iconName: "cards-playing",
        // iconName: "cards-playing-spade-multiple-outline",
        // iconName: "cards",
        iconClass: MaterialCommunityIcons,
      },
      king: {
        name: "king",
        iconName: "chess-king",
        iconClass: MaterialCommunityIcons,
      },
      // 'fedora': { name: 'fedora', iconName: 'hat-fedora', iconClass: MaterialCommunityIcons },

      // tech
      design: {
        name: "design",
        iconName: "drawing-box",
        iconClass: MaterialCommunityIcons,
      },
      code: { name: "code", iconName: "code", iconClass: Entypo },
      terminal: {
        name: "terminal",
        iconName: "codesquareo",
        iconClass: AntDesign,
        scale: 0.9,
      },
      circuit: {
        name: "circuit",
        iconName: "resistor-nodes",
        iconClass: MaterialCommunityIcons,
      },
      "flow-tree": {
        name: "flow-tree",
        iconName: "flow-tree",
        iconClass: Entypo,
        scale: 0.8,
      },
      equalizer: {
        name: "equalizer",
        iconName: "equalizer",
        iconClass: Fontisto,
        scale: 0.9,
      },
      robot: {
        name: "robot",
        iconName: "robot",
        iconClass: MaterialCommunityIcons,
      },
      industrial: {
        name: "industrial",
        iconName: "robot-industrial",
        iconClass: MaterialCommunityIcons,
      },

      // symbols
      creation: {
        name: "creation",
        iconName: "creation",
        iconClass: MaterialCommunityIcons,
      },
      shapes: {
        name: "shape",
        iconName: "shape",
        iconClass: MaterialCommunityIcons,
      },
      flame: { name: "flame", iconName: "flame", iconClass: Octicons },
      water: {
        name: "water",
        iconName: "water",
        iconClass: FontAwesome5,
        scale: 0.9,
      },
      drip: { name: "water", iconName: "water", iconClass: Entypo },
      "yin-yang": {
        name: "yin-yang",
        iconName: "yin-yang",
        iconClass: MaterialCommunityIcons,
      },
      check: {
        name: "check",
        iconName: "check-square",
        iconClass: FontAwesome,
      },
      target: {
        name: "target",
        iconName: "target",
        iconClass: MaterialCommunityIcons,
      },
      hashtag: {
        name: "hashtag",
        iconName: "hashtag",
        iconClass: Fontisto,
        scale: 0.9,
      },
      cone: { name: "cone", iconName: "safety-cone", iconClass: Foundation },
      no: { name: "no", iconName: "not-interested", iconClass: MaterialIcons },

      // material-community, hexagon-multiple, f6e0

      // case 'horse':
      //   return { iconName: 'horse', iconClass: FontAwesome5 }
      // case 'horse-head':
      //   return { iconName: 'horse-head', iconClass: FontAwesome5 }
      // // other chess icons
      // return { iconName: 'questioncircleo', iconClass: AntDesign }
    };
    if (includeHidden) {
      icons.hidden_icons = true;
      icons.note = {
        name: "note",
        iconName: "sticky-note",
        iconClass: FontAwesome5,
      };
      icons.text = {
        name: "text",
        iconName: "file-text-o",
        iconClass: FontAwesome,
      };
      icons.notes = {
        name: "notes",
        iconName: "note-multiple-outline",
        iconClass: MaterialCommunityIcons,
        scale: 0.8,
        rotation: 90,
      };
      icons.plus = {
        name: "plus",
        iconName: "plus",
        iconClass: Entypo,
      };
      icons.x = {
        name: "x",
        iconName: "close",
        iconClass: AntDesign,
      };
      icons.placeholder = {
        name: "placeholder",
        iconName: "border-none-variant",
        iconClass: MaterialCommunityIcons,
      };
      icons["open-book"] = {
        name: "open-book",
        iconName: "open-book",
        iconClass: Entypo,
      };
    }
    return icons;
  },
  unicode(name = "") {
    if (!!!name) name = "";
    if (!!!name) return "";
    let { iconName, iconClass } = iconHelpers.findIconClass(name);
    let IC = iconClass;
    let glyphs = IC.glyphMap;
    if (!glyphs) glyphs = IC.getRawGlyphMap();
    // let family = IC.getFontFamily()
    let glyphName = glyphs[iconName];
    let codespace = glyphs[iconName].toString(16);
    // return String.fromCodePoint(parseInt(glyphName, 16))

    let unicode = eval("'\\u{" + codespace + "}'");
    return unicode;
  },
  fontFamily(name = "") {
    if (!!!name) name = "";
    if (!!!name) return "";
    let { iconName, iconClass } = iconHelpers.findIconClass(name);
    let IC = iconClass;
    let family = IC.getFontFamily();
    if (family == "FontAwesome5Free-Regular") family = "FontAwesome5Free-Solid";
    return family;
  },
};

export default iconHelpers;
